import React from 'react';

function Hamburger(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M20.75 7.00244C20.75 6.65726 20.4702 6.37744 20.125 6.37744H3.875L3.78264 6.38422C3.48126 6.42886 3.25 6.68864 3.25 7.00244C3.25 7.34762 3.52982 7.62744 3.875 7.62744H20.125L20.2174 7.62066C20.5187 7.57602 20.75 7.31624 20.75 7.00244ZM20.125 11.3774C20.4702 11.3774 20.75 11.6573 20.75 12.0024C20.75 12.3162 20.5187 12.576 20.2174 12.6207L20.125 12.6274H3.875C3.52982 12.6274 3.25 12.3476 3.25 12.0024C3.25 11.6886 3.48126 11.4289 3.78264 11.3842L3.875 11.3774H20.125ZM20.125 16.3774C20.4702 16.3774 20.75 16.6573 20.75 17.0024C20.75 17.3162 20.5187 17.576 20.2174 17.6207L20.125 17.6274H3.875C3.52982 17.6274 3.25 17.3476 3.25 17.0024C3.25 16.6886 3.48126 16.4289 3.78264 16.3842L3.875 16.3774H20.125Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Hamburger;
